import { createReducer, on } from '@ngrx/store';
import { SubmissionFilters } from '../../models/submission-filters.model';
import {
  StudySaleSubmissionModel,
  SubmissionModel,
} from '../../models/submission.model';
import * as Actions from './submissions.action';
export interface SubmissionsState {
  isLoading: boolean;
  submissions: SubmissionModel[];
  filters: SubmissionFilters;
  studySubmissions: StudySaleSubmissionModel[];
  draftSubmissionCount: number;
}

export const initialState: SubmissionsState = {
  isLoading: false,
  submissions: [],
  filters: null,
  studySubmissions: [],
  draftSubmissionCount: null,
};

export const submissionsReducer = createReducer(
  initialState,

  on(Actions.GetUserSubmissions, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(Actions.GetUserSubmissionsSuccess, (state, { submissions }) => ({
    ...state,
    isLoading: false,
    submissions: submissions.map((submission) => {
      return {
        ...submission,
        status: submission.status,
      };
    }),
  })),
  on(Actions.GetSubmissionsByStudyIdSuccess, (state, { submissions }) => ({
    ...state,
    isLoading: false,
    studySubmissions: submissions?.map((submission) => {
      return {
        ...submission,
        status: submission.status,
      };
    }),
  })),
  on(Actions.CancelStudySubmissionSuccess, (state, { submissionId }) => ({
    ...state,
    isLoading: false,
    studySubmissions: state.studySubmissions.filter((submission) => {
      return submission.id !== submissionId;
    }),
  })),
  on(Actions.CancelSubmissionByIdSuccess, (state, { submissionId }) => ({
    ...state,
    isLoading: false,
    submissions: state.submissions.filter((submission) => {
      return submission.id !== submissionId;
    }),
  })),
  on(
    Actions.GetDraftSubmissionsCountSuccess,
    (state, { draftSubmissionCount }) => ({
      ...state,
      draftSubmissionCount,
    })
  ),
  on(Actions.SetFilters, (state, { filters }) => ({
    ...state,
    filters,
  })),
  on(Actions.ResetFilters, (state) => ({
    ...state,
    filters: new SubmissionFilters({}),
  }))
);
